import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExpiredPermissionUiStatic } from '@app/features/expired-permission-ui/expired-permission-ui.static';

export class UnathorizedInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		return next.handle(req).pipe(
			catchError((error) => {
				if (error.status === 401) {
					ExpiredPermissionUiStatic.open();
				}
				return throwError(error);
			}),
		);
	}
}